var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file"},[(_vm.model)?_c('p',[_vm._v(_vm._s(_vm.model.name))]):_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":_vm.uploadFile}},[_vm._v("\n\t\tSubir archivo "),_c('i',{staticClass:"el-icon-upload el-icon-right"})]),_c('input',{ref:"file",attrs:{"type":"file"},on:{"change":_vm.handleFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }